import type { AppDataSource } from './app-data.types';
import { getCanaryVariant } from '@/logic/experiments/get-canary-variant';
import { NATIVE_API_CANARY } from '@/logic/experiments/canaries';

export const getAppDataSource = async (): Promise<AppDataSource> => {
    try {
        const canaryVariant = await getCanaryVariant(NATIVE_API_CANARY);
        return canaryVariant === 'native-api' ? 'native-api' : 'page-config';
    } catch {
        return 'page-config';
    }
};
